import * as yup from 'yup';

import { ChoiceValue } from 'utils/library';

import { HAZARD_FIELD } from '../../constants';

export type CreateHazardValues = {
  name: string;
  category: ChoiceValue;
  whoMightBeHarmed: string;
  howMightBeHarmed: string;
};

export const createHazardSchema = yup.object({
  name: yup.string().trim().required('Enter a hazard'),
  category: yup
    .mixed<NonNullable<ChoiceValue>>()
    .nullable()
    .test('chosen', 'Choose a category', (value) => Boolean(value?.[0]?.key))
    .required('Choose a category'),
  whoMightBeHarmed: yup.string().trim().required('Enter who might be harmed'),
  howMightBeHarmed: yup.string().trim().required('Enter how they might be harmed'),
});

export const toFieldValues = (values: CreateHazardValues): Record<string, string | string[] | null> => ({
  [HAZARD_FIELD.category]: values.category?.map(({ key }) => key) ?? null,
  [HAZARD_FIELD.whoMightBeHarmed]: values.whoMightBeHarmed.trim(),
  [HAZARD_FIELD.howMightBeHarmed]: values.howMightBeHarmed.trim(),
});
